/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";

/**
 *
 * @export
 * @interface MessageTypeCreateRequest
 */
export interface MessageTypeCreateRequest {
  /**
   *
   * @type {string}
   * @memberof MessageTypeCreateRequest
   */
  groupId: string;
  /**
   *
   * @type {string}
   * @memberof MessageTypeCreateRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof MessageTypeCreateRequest
   */
  md5: string;
  /**
   *
   * @type {string}
   * @memberof MessageTypeCreateRequest
   */
  definition: string;
  /**
   *
   * @type {string}
   * @memberof MessageTypeCreateRequest
   */
  note?: string;
  /**
   *
   * @type {object}
   * @memberof MessageTypeCreateRequest
   */
  context?: object;
}

export function MessageTypeCreateRequestFromJSON(
  json: any
): MessageTypeCreateRequest {
  return MessageTypeCreateRequestFromJSONTyped(json, false);
}

export function MessageTypeCreateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MessageTypeCreateRequest {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    groupId: json["group_id"],
    name: json["name"],
    md5: json["md5"],
    definition: json["definition"],
    note: !exists(json, "note") ? undefined : json["note"],
    context: !exists(json, "context") ? undefined : json["context"],
  };
}

export function MessageTypeCreateRequestToJSON(
  value?: MessageTypeCreateRequest | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    group_id: value.groupId,
    name: value.name,
    md5: value.md5,
    definition: value.definition,
    note: value.note,
    context: value.context,
  };
}
